// extracted by mini-css-extract-plugin
export var table = "_xh-0";